import React from 'react';

import type { Entity } from 'collections/types';
import type { ColumnRenderers } from 'components/common/EntityDataTable';

import TitleCell from './cells/TitleCell';

const customColumnRenderers: ColumnRenderers<Entity> = {
  attributes: {
    name: {
      renderCell: (name: Entity['name'], collectionEntity: Entity) => (
        <TitleCell name={name} id={collectionEntity.id} type={collectionEntity.type} />
      ),
    },
  },
};

export default customColumnRenderers;
